import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type RQ_IM = {
    serviceIn: string,
    visaRequested: string,
    fullName: string,
    sex: string,
    dateOfBirth: string,
    placeOfBirth: string,
    countryOrTerritory: string,
    citizenship: string,
    currentCountry: string,
    citizenStatus: string,
    previousTerritoryDifferent: string,
    maritialStatus: string,
    spouseName: string,
    previouslyMarried: string,
    previousSpouseName: string,
    previousSpouseDob: string,
    typeOfRelationship: string, 
    previousSpouseFrom: string,
    previousSpouseTill: string,
    languages: string,
    communicationFrench: string,
    assessProficiency: string,
    passportNumber: string,
    countryOfPassportIssued: string, 
    issueDate: string,
    expiryDate: string,
    nationalDocumentNumber: string,
    nationalDocumentIssuer: string,
    nationalDocumentIssueDate: string,
    nationalDocumentExpiryDate: string,
    greenCard: string,
    greenCardNumber: string,
    greenCardExpiry: string,
    contactStreet: string,
    contactCity: string,
    contactCountry: string,
    residentialAddressSame: string,
    residentialStreet: string,
    residentialCity: string,
    residentialCountry: string,
    telephone: string,
    contactType: string,
    contactCountryCode: string,
    contactNumber            : string,
    contactFax: string,
    contactType2: string,
    contactCountryCode2: string,
    contactNumber2: string,
    contactEmail: string,
    canadaVisitPurpose: string,
    canadaVisitedFrom: string,
    canadaVisitedTill: string,
    fundsAvailableCAD: string,
    nameInCanada: string,
    addressInCanada: string,
    educationSecondary: string,
    educationStartedYear: string,
    educationStartedMonth: string,
    educationTillYear: string,
    educationTillMonth: string,
    fieldOfStudent: string,
    schoolName: string,
    schoolCity: string,
    schoolCountry: string,
    employmentFromYear: string,
    employmentFromMonth: string,
    employmentToYear: string,
    employmentToMonth: string,
    currentOccupation: string,
    currentCompanyName: string,
    currentCompanyCity: string,
    currentCompanyCountry: string,
    tbInLast2Years: string,
    physicalMentalDisorder: string,
    nameOfFamilyMember: string,
    withoutAuthorization: string,
    visaDenied: string,
    previouslyApplied: string,
    yes2abcDetials: string,
    criminalOffence: string,
    criminalDetails: string,
    militaryVoluntary: string,
    detailsVoluntaryServed: string,
    associatedWithPoliticalParty: string,
    witnessedCivilians: string,
  
  };
  
  export type ImmigrationState = {
    // user: User | null;
    rq_im: RQ_IM | null;
  };
  
  const initialState: ImmigrationState = {
    rq_im: null,
  };
  
  const immigrationSlice = createSlice({
    name: "immigrationSlice",
    initialState,
    reducers: {
      setRequestImmegration: (state, action: PayloadAction<RQ_IM>) => {
        state.rq_im = action.payload;
      }
    },
    extraReducers: () => {},
  });
  
  export const { setRequestImmegration } = immigrationSlice.actions;
  export default immigrationSlice.reducer;